export { default } from "./NoSsr.mjs";